import React, { useState } from 'react';
import meat from '../assets/images/products/meatHome.jpg';
import chicken from '../assets/images/products/Frozen Whole Chicken Griller.jpg';
import fish from '../assets/images/products/fish.jpg';

import FrozenChickenLegbone from '../assets/images/products/Frozen Chicken Leg skinless.jpg'
import FrozenChickenDrumsticks from '../assets/images/products/Frozen Chicken Drumsticks.jpg'
import chicken3 from '../assets/images/products/Frozen Chicken Leg Quarter.jpg'
import chicken5 from '../assets/images/products/Frozen Chicken Leg Boneless Skin-on.jpg'
import chicken6 from '../assets/images/products/Frozen Whole Chicken Griller.jpg'
import chicken7 from '../assets/images/products/Frozen Chicken Leg Bone-in Skin-on.jpg'
import chicken8 from '../assets/images/products/Frozen Chicken Breast.jpg'
import chicken10 from '../assets/images/products/frozen chicken shawrma.jpg'

import chicken2 from '../assets/images/products/Frozen Chicken Wings.jpg'
import chicken4 from '../assets/images/products/Frozen Chicken Breast Bone-in Skin-on.jpg'

// Meats

import meat1 from '../assets/images/products/meat/Meat Beef Brisket.jpg'
import meat2 from '../assets/images/products/meat/Meat Beef Top Sirloin.jpg'
import meat3 from '../assets/images/products/meat/Whole beef Tenderloin.jpg'
import meat4 from '../assets/images/products/meat/Meat Beef Ribeye (Bone-in).jpg'
import meat5 from '../assets/images/products/meat/Meat Beef Ribeye (Boneless).jpg'
import meat6 from '../assets/images/products/meat/Meat Beef Flank Steak.jpg'
import meat7 from '../assets/images/products/meat/Meat Beef Short Ribs (Boneless).jpg'
import meat8 from '../assets/images/products/meat/Meat Beef Short Ribs (Bone-in).jpg'
import meat9 from '../assets/images/products/meat/Meat Beef Chuck Roast.jpg'
import meat10 from '../assets/images/products/meat/Meat Beef Shanks (Shins).jpg'
import meat11 from '../assets/images/products/meat/Meat Beef Brisket, First cut, Trimmed.jpg'
import meat12 from '../assets/images/products/meat/Meat Beef Eye round.jpg'
import meat13 from '../assets/images/products/meat/lamp.jpg'

import meat14 from '../assets/images/products/meat/lamp leg.jpg'
import meat15 from '../assets/images/products/meat/lamp cut shoulder.jpg'

import meat16 from '../assets/images/products/meat/lamb shank.jpg'

import meat17 from '../assets/images/products/meat/lamb trimjpg.jpg'

import meat18 from '../assets/images/products/meat/lamb chump.jpg'
import meat19 from '../assets/images/products/meat/lamb rack.jpg'
import meat20 from '../assets/images/products/meat/Lamb Rump Square Cut.jpg'

import meat21 from '../assets/images/products/meat/meat buffalo.jpg'
import meat22 from '../assets/images/products/meat/meat buffalo2.jpg'
import meat23 from '../assets/images/products/meat/meat buffalo3.jpg'

import all from '../assets/images/products/meatHome.jpg'
import { t } from 'i18next';

export const ProductsPage = () => {
    const [selectedCategory, setSelectedCategory] = useState(t('category.all'));

    const categories = [
        { id: 0, name: t('category.all'), image: all }, // 'All' category with id 0
        { id: 1, name: t('category.Chicken'), image: chicken },
        { id: 2, name: t('category.meat'), image: meat },
        { id: 3, name: t('category.meatlamb'), image: meat13 },
        { id: 4, name: t('category.meatbuffalo'), image: meat21 },
        { id: 5, name: t('category.fish'), image: fish },
        // Add more categories as needed
    ];

    const dataArray = [
        { id: 6, category_name: t('category.Chicken'), image: chicken10, name: t('products.chicken10') },
        { id: 2, category_name: t('category.Chicken'), image: FrozenChickenDrumsticks, name: t('products.chicken2') },
        { id: 4, category_name: t('category.Chicken'), image: chicken3, name: t('products.chicken4') },
        { id: 1, category_name: t('category.Chicken'), image: FrozenChickenLegbone, name: t('products.chicken1') },
        { id: 5, category_name: t('category.Chicken'), image: chicken5, name: t('products.chicken6') },
        { id: 6, category_name: t('category.Chicken'), image: chicken8, name: t('products.chicken9') },
        { id: 5, category_name: t('category.Chicken'), image: chicken7, name: t('products.chicken8') },
        { id: 5, category_name: t('category.Chicken'), image: chicken4, name: t('products.chicken5') },
        { id: 3, category_name: t('category.Chicken'), image: chicken2, name: t('products.chicken3') },
        { id: 5, category_name: t('category.Chicken'), image: chicken6, name: t('products.chicken7') },


      
        { id: 7, category_name: t('category.meat'), image: meat7, name: t('products.meat7') },
        { id: 7, category_name: t('category.meat'), image: meat8, name: t('products.meat8') },
        { id: 7, category_name: t('category.meat'), image: meat9, name: t('products.meat9') },
        { id: 7, category_name: t('category.meat'), image: meat10, name: t('products.meat10') },
        { id: 7, category_name: t('category.meat'), image: meat11, name: t('products.meat11') },
        { id: 7, category_name: t('category.meat'), image: meat12, name: t('products.meat12') },
  { id: 7, category_name: t('category.meat'), image: meat1, name: t('products.meat1') },
        { id: 7, category_name: t('category.meat'), image: meat2, name: t('products.meat2') },
        { id: 7, category_name: t('category.meat'), image: meat3, name: t('products.meat3') },
        { id: 7, category_name: t('category.meat'), image: meat4, name: t('products.meat4') },
        { id: 7, category_name: t('category.meat'), image: meat5, name: t('products.meat5') },
        { id: 7, category_name: t('category.meat'), image: meat6, name: t('products.meat6') },

      { id: 7, category_name: t('category.meatlamb'), image: meat17, name: t('products.lamb5') },
        { id: 7, category_name: t('category.meatlamb'), image: meat18, name: t('products.lamb6') },
        { id: 7, category_name: t('category.meatlamb'), image: meat19, name: t('products.lamb7') },
        { id: 7, category_name: t('category.meatlamb'), image: meat20, name: t('products.lamb8') },
        { id: 7, category_name: t('category.meatlamb'), image: meat13, name: t('products.lamb1') },
        { id: 7, category_name: t('category.meatlamb'), image: meat14, name: t('products.lamb2') },
        { id: 7, category_name: t('category.meatlamb'), image: meat15, name: t('products.lamb3') },
        { id: 7, category_name: t('category.meatlamb'), image: meat16, name: t('products.lamb4') },
  
        { id: 7, category_name: t('category.meatbuffalo'), image: meat22, name: t('products.meatbuffalo') },
        { id: 7, category_name: t('category.meatbuffalo'), image: meat23, name: t('products.meatbuffalo') },
        { id: 7, category_name: t('category.meatbuffalo'), image: meat21, name: t('products.meatbuffalo') },
        // { id: 8, category_name: 'Fish', image: fish, name: '' },
        // Add more objects as needed
    ];

    const filteredData = selectedCategory === t('category.all')
        ? dataArray
        : dataArray.filter((item) => item.category_name === selectedCategory);

    return (
        <div className="mt-12 px-4 md:px-20">
            {/* Section Header */}
            <div className="text-center mb-10">
                <h2 className="text-4xl md:text-5xl font-bold text-[#1a0080]">
                    {t('products.heading1')}
                </h2>
                <p
                    data-aos="zoom-in"
                    data-aos-duration="500"
                    className="text-gray-500 text-sm md:text-base max-w-md mx-auto mt-2 leading-relaxed"
                >
                    {t('products.title')}
                </p>
            </div>

            {/* Categories Scroll */}
            <div className="flex justify-center mb-8">
                <div className="flex overflow-x-auto  py-2 scrollbar-hide">
                    {categories.map((category) => (
                        <div key={category.id} className="flex-shrink-0 mx-2">
                            <div
                                onClick={() => setSelectedCategory(category.name)}
                                className={`flex items-center gap-2 w-36 md:w-48 h-12 px-4 rounded-full cursor-pointer transition-transform duration-300 shadow-lg
              ${selectedCategory === category.name
                                        ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white'
                                        : 'bg-white border-2 border-[#1a0080] text-[#1a0080] hover:scale-105'
                                    }`}
                            >
                                <img
                                    src={category.image}
                                    alt={category.name}
                                    className="w-10 h-10 rounded-full object-cover bg-white p-1"
                                />
                                <p className="text-sm md:text-base font-medium truncate">
                                    {category.name}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Products Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
                {filteredData.map((item, index) => (
                    <div
                        key={index}
                        className="relative group overflow-hidden rounded-2xl shadow-lg cursor-pointer transform transition-transform duration-300 hover:scale-105"
                    >
                        {/* Product Image */}
                        <img
                            src={item.image}
                            alt={item.name}
                            className="w-full h-64 md:h-72 object-cover rounded-2xl group-hover:scale-110 transition-transform duration-500"
                        />

                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl flex items-end p-4">
                            <h3 className="text-white font-semibold text-lg md:text-xl">
                                {item.name}
                            </h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
};
